// extracted by mini-css-extract-plugin
export default {"identifier":"TaxiCards_identifier__sBQwe"};